import ContactSupport from './ContactSupport.view';

export default ContactSupport;